import getUserTier from './api/getUserTier';

export enum SubscriptionType {
  GOLD_OLD = 'gold_old',
  PRO = 'pro',
  MAX_STARTER = 'max_starter',
  MAX_PERFORMANCE = 'max_performance',
}

const PRO_SUBSCRIPTIONS: ReadonlySet<string> = new Set([
  SubscriptionType.GOLD_OLD,
  SubscriptionType.PRO,
  SubscriptionType.MAX_STARTER,
  SubscriptionType.MAX_PERFORMANCE,
]);

/**
 * Sync check against an already-resolved tier id (e.g. from useUserProfile).
 * Use when the tier is already in hand and an extra network round-trip
 * (isProUser) isn't warranted.
 */
export const isProTierId = (tierId: string | null | undefined): boolean =>
  tierId ? PRO_SUBSCRIPTIONS.has(tierId) : false;

const isProUser = async (): Promise<boolean> => {
  const tier = await getUserTier();
  return isProTierId(tier?.id);
};

export default isProUser;
